import React from 'react';
import { Column } from '../../containers';

type Props = {
  readonly children: React.ReactNode;
};

/**
 * Web: shrink-wrap to footnote text width so anchored buttons share the same horizontal
 * bounds as the footnote line (e.g. support message footer on desktop).
 */
export const AnchoredFootnoteLayout = ({ children }: Props) => (
  <Column
    centerHorizontally
    flexShrink={0}
    // @ts-expect-error web-only CSS (fit-content) not in RN ViewStyle
    // eslint-disable-next-line react-native/no-inline-styles -- web-only fit-content pairs footnote width with buttons
    style={{ alignSelf: 'center', width: 'fit-content', maxWidth: '100%' }}
  >
    {children}
  </Column>
);
